import React from "react";
import "../styles/Skeleton.css";

/**
 * Skeleton placeholder for loading states.
 * Usage: <Skeleton width="60%" height="20px" />
 * Or use preset variants: <Skeleton variant="card" />
 */
const Skeleton = ({ width, height, variant, style, className = "" }) => {
  if (variant === "card") {
    return (
      <div className={`skeleton-card ${className}`} style={style}>
        <div className="skeleton-line skeleton-shimmer" style={{ width: "40%", height: "14px" }} />
        <div className="skeleton-line skeleton-shimmer" style={{ width: "80%", height: "12px", marginTop: "10px" }} />
        <div className="skeleton-line skeleton-shimmer" style={{ width: "60%", height: "12px", marginTop: "8px" }} />
      </div>
    );
  }

  if (variant === "avatar") {
    return (
      <div
        className={`skeleton-avatar skeleton-shimmer ${className}`}
        style={style}
      />
    );
  }

  if (variant === "dashboard") {
    return (
      <div className={`skeleton-dashboard ${className}`}>
        {/* Hero skeleton */}
        <div className="skeleton-hero">
          <div className="skeleton-line skeleton-shimmer" style={{ width: "50%", height: "22px" }} />
          <div className="skeleton-line skeleton-shimmer" style={{ width: "70%", height: "14px", marginTop: "10px" }} />
        </div>

        {/* Alert skeleton */}
        <div className="skeleton-alert-card skeleton-shimmer" />

        {/* Actions skeleton */}
        <div className="skeleton-actions">
          <div className="skeleton-action-btn skeleton-shimmer" />
          <div className="skeleton-action-btn skeleton-shimmer" />
        </div>

        {/* News skeleton */}
        <div className="skeleton-news-card skeleton-shimmer" />
      </div>
    );
  }

  return (
    <div
      className={`skeleton-line skeleton-shimmer ${className}`}
      style={{ width: width || "100%", height: height || "14px", ...style }}
    />
  );
};

export default Skeleton;

